const LANDSCAPES = {
    "kokopelli trail": {
        finish: "kokopelli",
        waypoints: {
            "rabbit valley": "rabbit-valley",
            westwater: "westwater",
            "dewey bridge": "dewey-bridge",
            "fisher towers": "fisher-towers",
            moab: "moab",
        },
    },
    "the long path": {
        finish: "long-path",
        waypoints: {
            "harriman state park": "harriman",
            "sam's point": "sams-point",
            "wittenberg mountain": "wittenberg",
            "schoharie valley": "schoharie",
            altamont: "altamont",
        },
    },
    "great allegheny passage": {
        finish: "great-allegheny-passage",
        waypoints: {
            "west newton": "west-newton",
            connellsville: "connellsville",
            ohiopyle: "ohiopyle",
            meyersdale: "meyersdale",
            cumberland: "cumberland",
        },
    },
    "length of britain": {
        finish: "length-of-britain",
        waypoints: {
            bristol: "bristol",
            "peak district": "peak-district",
            "lake district": "lake-district",
            cairngorms: "cairngorms",
            "john o' groats": "john-o-groats",
        },
    },
    "route 66": {
        finish: "route-66",
        waypoints: {
            "st. louis": "st-louis",
            "oklahoma city": "oklahoma-city",
            "santa fe": "santa-fe",
            flagstaff: "flagstaff",
            "santa monica": "santa-monica",
        },
    },
    "great saunter, manhattan": {
        finish: "great-saunter",
        waypoints: {
            "hudson river park": "hudson-river-park",
            "little red lighthouse": "little-red-lighthouse",
            "inwood hill": "inwood-hill",
            "carl schurz park": "carl-schurz-park",
            "water street": "water-street",
        },
    },
};
/** Curated artwork is scoped to its route; unknown places keep the enamel master. */
export function medalLandscape(routeName, waypoint) {
    const route = LANDSCAPES[routeName.trim().toLowerCase()];
    const place = waypoint?.trim().toLowerCase().replace(/’/g, "'");
    return place === undefined ? route?.finish : route?.waypoints[place];
}
/** Position selects the same frame and metal finish in thumbnails and 3D assets. */
export function medalLandscapeOrdinal(landscape) {
    if (!landscape)
        return 0;
    for (const route of Object.values(LANDSCAPES)) {
        const index = Object.values(route.waypoints).indexOf(landscape);
        if (index !== -1)
            return index + 1;
    }
    return 0;
}
//# sourceMappingURL=medal-landscape.js.map